import React, { useEffect, useState } from 'react';

import Bugsnag from '@bugsnag/js';

import { bugsnagNotify } from 'src/lib/bugsnag';
import { textifyError } from 'src/lib/error';

import {
  CreateIcon,
  DeleteIcon, DoneIcon, ErrorIcon,
  JiraIcon, LoadingIcon,
  PdIcon, WaitIcon
} from 'src/views/components/commonIcons';

import WebhooksTableSummary from './WebhooksTableSummary';
import { webhooksTasksRunner } from './webhooksTasksRunner';

import './WebhooksTasksTable.css';

const WebhooksTasksTable = ({ tasks, isRunning, onDone }) => {
  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    setStatuses(Array.from({ length: tasks.length }).map(() => ({ status: 'wait' })));
  }, [tasks]);

  useEffect(() => {
    if (!isRunning || statuses.length !== tasks.length) return;

    const index = statuses.findIndex(s => !s || s.status === 'wait');
    const alredyStartedCount = statuses.filter(t => t.status === 'inprogress').length;
    if (index === -1 && alredyStartedCount === 0 && onDone) {
      onDone({ hasErrors: statuses.filter(s => s.status === 'error').length > 0 });
    }

    if (index === -1 || alredyStartedCount >= 3) return;

    const updateCurrentStatus = (state => {
      setStatuses(statuses => {
        const copy = [...statuses];
        copy[index] = { ...copy[index] || {}, ...state };
        return copy;
      });
    });

    updateCurrentStatus({ status: 'inprogress' });
    webhooksTasksRunner(tasks[index])
      .then(() => updateCurrentStatus({ status: 'done' }))
      .catch(error => {
        Bugsnag.leaveBreadcrumb('Processing webhook create/delete task', { ...tasks[index] });
        bugsnagNotify(error);
        updateCurrentStatus({
          error: textifyError(error),
          status: 'error'
        });
      });
  }, [isRunning, onDone, statuses, tasks]);

  const presentTask = (task, index) => {
    const { status, error } = statuses[index] || { status: 'wait' };
    const { type, action, service, jql, events, info } = task;
    let pdWebhookVersion = '';
    if (type === 'pd') pdWebhookVersion = 'webhook v2';
    if (type === 'subscription') pdWebhookVersion = 'webhook v3';

    return (
      <tr className={`bgcolor-status-${status}`} key={index}>
        <td style={{ width: '20px', padding: '0' }}>{index + 1}</td>
        <td style={{ width: '20px', padding: '0' }}>{action === 'delete' ? <DeleteIcon/> : <CreateIcon/> }</td>
        <td style={{ width: '20px', padding: '0' }}>{type === 'pd' || type === 'subscription' ? <PdIcon/> : <JiraIcon/>}</td>
        <td style={{ width: '20px', padding: '0' }}>
          {status === 'wait' && <WaitIcon/>}
          {status === 'inprogress' && <LoadingIcon/>}
          {status === 'error' && <ErrorIcon/>}
          {status === 'done' && <DoneIcon/>}
        </td>
        <td>
          {error && <div>Error: {error}</div>}
          {service && <div>service: {service.summary} ({pdWebhookVersion})</div>}
          {jql && <div>jql: {`${jql} on ${events.join(', ')}`}</div>}
          {info && <div>{info}</div>}
        </td>
      </tr>
    );
  };

  return (
    <div>
      <div style={{ maxHeight: 350, overflow: 'auto' }}>
        <table className="webhooks-tasks-table">
          <tbody>
            { tasks.map(presentTask) }
          </tbody>
        </table>
      </div>
      <WebhooksTableSummary statuses={statuses} isRunning={isRunning}/>
    </div>
  );
};

export default WebhooksTasksTable;
